module.exports = __webpack_public_path__ + "img/web_mockup.ea17e09d.png";